import {
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import PkCommonTitle from "../../../components/common/PkCommonTitle";
import PkCommonArrow from "../../../components/common/PkCommonArrow";
import { getLayoutLead } from "../../../components/layout/getLayoutLead";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutView } from "../../../components/layout/getLayoutView";
export function Works() {
  return (
    <Box sx={{ backgroundColor: "white" }}>
      <Box>
        {getLayoutLead(
          <>
            At Polycaik, we understand the importance of perspective, the role
            narratives play in shaping it, and the power of expressing it
            through storytelling.
          </>,
          { fontSize: "1.5rem" },
        )}
        <PkCommonArrow color={"white"} />
        {getLayoutView(
          <>
            THE <span style={{ fontFamily: "Lato-Bold" }}> SITUATION </span>
          </>,
          [
            getLayoutText(
              <>
                We know there is a representation problem in media and
                entertainment.
              </>,
            ),
            getLayoutText(
              <>
                We know the same old narratives are rebranded to push negative
                stereotypes about a culture or value systems contradictory to
                those of that culture.
              </>,
            ),
            getLayoutText(
              <>
                We know the only way to tackle this issue is to introduce
                content that will help audiences develop a more balanced view of
                the cultures portrayed in media.{" "}
                <span>
                  However, traditional channels for storytelling are resistant
                  to changing the nature of the content they serve to the
                  public.
                </span>
              </>,
            ),
          ],
          [4, 4, 4],
          {
            p: `8rem 10%`,
            backgroundColor: (theme) => theme.palette.grey[800],
            "& .MuiTypography-root:not(.MuiTypography-caption)": {
              color: (theme) => theme.palette.grey[100],
            },
          },
        )}
        <PkCommonArrow color={"white"} upward={true} />
        {getLayoutLead(
          <>
            Thus, Polycaik came to be — out of the need for technology that
            gives people the power to leverage new media as a platform for
            storytelling and expression.
          </>,
          { fontSize: "1.5rem" },
        )}
      </Box>
      <Box>
        <PkCommonArrow color={"white"} />
        {getLayoutView(
          <>
            THE <span style={{ fontFamily: "Lato-Bold" }}> TEAM </span>
          </>,
          [
            getLayoutText(
              <>
                New media — game applications — offer unique opportunities for
                storytelling due to their interactive nature, and we are
                committed to developing technologies that help our customers
                thrive in this new arena.
              </>,
            ),
            <Grid container sx={{ ml: "auto" }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={6}
                key={`tagline`}
                sx={{ pt: 6, pr: 4 }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    pb: 3,
                    color: (theme) => theme.palette.grey[700],
                    textAlign: "center",
                  }}
                >
                  Let's build together.
                </Typography>
              </Grid>
              {[
                {
                  image:
                    "https://website-img.polycaik.com/w/asset/photo/3b8b42bf84914b3ca8125ac62610c8d7.png",
                  name: "Jeff Fleurimond",
                  text: "CEO",
                  type: "Creator of polycaik",
                },
                {
                  image:
                    "https://website-img.polycaik.com/w/asset/photo/23f86ca6542f4eff8ac47c93ba62d843.png",
                  name: "Iyare Oronsaye",
                  text: "Creative Director",
                  type: "Seer of design",
                },
              ].map((m, i) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={`image${i}`}>
                  <Card
                    sx={{
                      p: 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CardMedia
                      sx={{ maxWidth: "150px" }}
                      component="img"
                      image={m.image}
                      src={m.image}
                      alt={`image${i}`}
                    />
                    <CardContent sx={{ p: 0, pt: 4 }}>
                      <PkCommonTitle show={m} />
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>,
          ],
          [9, 11],
          {
            py: `8rem`,
            backgroundColor: (theme) => theme.palette.grey[800],
            "& .MuiCard-root": {
              backgroundColor: (theme) => theme.palette.grey[800],
              "& span": {
                color: (theme) => theme.palette.grey[500],
              },
            },
            "& .MuiTypography-root:not(.MuiTypography-caption)": {
              color: (theme) => theme.palette.grey[100],
            },
            "& .MuiGrid-container": {
              justifyContent: `flex-start`,
            },
          },
        )}
      </Box>
      <Box>
        <PkCommonArrow color={(theme) => theme.palette.grey[800]} />
        {getLayoutView(
          <>
            THE <span style={{ fontFamily: "Lato-Bold" }}> OUTCOME </span>
          </>,
          [
            getLayoutText(
              <>
                A community with the power to interactively tell their stories
                with minimum outside influence, their way, immersive, and true
                to their vision —{" "}
                <span>a step towards changing the narrative.</span>
              </>,
            ),
            <Button
              sx={{
                p: 1,
                mt: 3,
                width: "100%",
                maxWidth: "300px",
              }}
              variant="contained"
              href={"/developers"}
            >
              LEARN MORE
            </Button>,
          ],
          [10],
          {
            py: `8rem`,
            color: (theme) => theme.palette.grey[700],
            backgroundColor: "white",
            backgroundImage: {
              lg: `linear-gradient(0.2turn, white 75%, #fbe080 75%)`,
            },
            "& span": {
              fontFamily: "Lato-Bold",
            },
            "& .MuiGrid-container": {
              justifyContent: `flex-start`,
            },
          },
        )}
      </Box>
    </Box>
  );
}
